export const itemsPath = '/'
export const componentsString = '/components'
export const stylesPath = `${itemsPath}:id`
export const componentsPath = `${stylesPath}${componentsString}`
